module.exports = __webpack_public_path__ + "img/pds_cursor2.f03067c6.svg";